export default "__VITE_ASSET__2252d790__"